import React, { FC, useEffect } from 'react';
import { Button, Grid } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Input } from '../Inputs';
import ContentWrapper from '../layouts/ContentWrapper/ContentWrapper';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import { Countries } from '../../module';

const useStyle = makeStyles((theme) => ({
  btn: {
    marginRight: theme.spacing(2),
  },
}));

const ForeignCities: FC<{ onSubmit?: (T: any, E: any) => void; value?: any }> = ({ onSubmit = () => {}, value }) => {
  const style = useStyle();
  const { handleSubmit, control, errors, reset, formState, getValues } = useForm({
    defaultValues: value,
  });

  const handleSearchBox = (value: any) => {
    const filters: any = {};
    for (let item in value) {
      if (item === 'fullName' && value[item] && value[item] !== '') {
        filters[item + '_contains'] = value[item] && value[item].length > 1 ? value[item].slice(1) : value[item];
      }
      if (item === 'shortName' && value[item] && value[item] !== '') {
        filters[item + '_contains'] = value[item] && value[item].length > 1 ? value[item].slice(1) : value[item];
      }
      if (item === 'dirCountry' && value[item] && value[item] !== '') {
        filters[item] = value[item] ? { id: value[item].value } : {};
      }
    }
    onSubmit(filters, getValues());
  };

  return (
    <ContentWrapper>
      <form onSubmit={handleSubmit(handleSearchBox)}>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Input label="Название города" control={control} error={!!errors['fullName']} name="fullName" />
          </Grid>
          <Grid item xs={3}>
            <Input label="Краткое название" control={control} error={!!errors['shortName']} name="shortName" />
          </Grid>
          <Grid item xs={3}>
            <Countries label="Страна" control={control} error={!!errors['dirCountry']} name="dirCountry" />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="outlined"
              className={style.btn}
              color="primary"
              type="button"
              onClick={() => {
                onSubmit({}, {});
                reset({});
              }}
              size="small"
              startIcon={<ClearIcon />}
            >
              Сброс
            </Button>
            <Button
              variant="outlined"
              color="primary"
              type="submit"
              size="small"
              className={style.btn}
              startIcon={<SearchIcon />}
              disabled={!formState.isDirty}
            >
              Поиск
            </Button>
          </Grid>
        </Grid>
      </form>
    </ContentWrapper>
  );
};

export default ForeignCities;
